module.exports = __webpack_public_path__ + "img/loader.878c9768.gif";